<template>
  <HeaderApp />
  <div
    :class="
      'mx-2 mt-14 mb-5 h-full bg-white dark:bg-gray-900 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 no-print ' +
      ($store.getters['isRtl'] ? $store.state.navbar.isSidebarCollapsed
          ? ' md:mr-20 '
          : ' md:mr-60 '
        : $store.state.navbar.isSidebarCollapsed
        ? ' md:ml-20  '
        : ' md:ml-60  ')
    "
  >
    <!-- Header Section -->
    <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
      <h1 class="text-xl font-semibold text-gray-900 dark:text-white">
        {{ $t("add_items") }}
      </h1>
    </div>

    <!-- Form Section -->
    <div class="px-6 py-4">
      <div class="">
        <form @submit="addSaleItem">
          <div class="grid gap-x-6 mb-6 md:grid-cols-2">
            <div class="flex">
              <div class="w-full">
                <BaseInput
                  v-model="i_id"
                  type="text"
                  :label="$t('item_barcode')"
                  :placeholder="$t('item_barcode')"
                  :rules="rules"
                  :isError="checkRulesIsError(i_id, 'add', this.rules).isError"
                  :errorMsg="
                    checkRulesIsError(i_id, 'add', this.rules).errorMsg
                  "
                />
              </div>
              <div class="w-2" v-if="linkDrop !== ''"></div>

              <div
                class="cursor-pointer w-2/12 lg:w-1/12 text-white text-2xl bg-primaryColor p-1 my-8 rounded-lg hover:shadow-md text-center"
              
                @click="generateBarcode"
              >
                #
              </div>
            </div>
            <BaseInput
              v-model="i_name"
              :label="$t('item_name')"
              :placeholder="$t('item_name')"
              :rules="rules"
              :isError="checkRulesIsError(i_name, 'add', this.rules).isError"
              :errorMsg="checkRulesIsError(i_name, 'add', this.rules).errorMsg"
            /><DropdownInput
              v-model="ca_id"
              :placeholder="$t('choose_item_category')"
              :label="$t('item_category')"
              :items="convertToListIdValueCategory"
              :rules="rules_dropdown"
              :isError="
                checkRulesIsError(ca_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(ca_id, 'add', this.rules_dropdown).errorMsg
              "
              linkDrop="/item-category"
            /><DropdownInput
              v-model="un_id"
              :label="$t('item_unit')"
              :items="convertToListIdValueUnits"
              :placeholder="$t('choose_item_unit')"
              :rules="rules_dropdown"
              :isError="
                checkRulesIsError(un_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(un_id, 'add', this.rules_dropdown).errorMsg
              "
              linkDrop="/item-unit"
            />

            <BaseInput
              v-model="i_sale_price"
              type="number"
              :label="$t('sale_price')"
              :placeholder="$t('sale_price')"
              :rules="rules"
              :isError="
                checkRulesIsError(i_sale_price, 'add', this.rules).isError
              "
              :errorMsg="
                checkRulesIsError(i_sale_price, 'add', this.rules).errorMsg
              "
            />
            <DropdownInput
              v-model="cur_id"
              :label="$t('currency_type')"
              :items="convertToListIdValue"
              :placeholder="$t('choose_currency_type')"
              :rules="rules_dropdown"
              :isError="
                checkRulesIsError(cur_id, 'add', this.rules_dropdown).isError
              "
              :errorMsg="
                checkRulesIsError(cur_id, 'add', this.rules_dropdown).errorMsg
              "
            />
            <TextAreaInput
              v-model="i_desc"
              :label="$t('item_description')"
              :placeholder="$t('item_description')"
              :rules="no_rule"
              :isError="checkRulesIsError(i_desc, 'add', this.no_rule).isError"
              :errorMsg="
                checkRulesIsError(i_desc, 'add', this.no_rule).errorMsg
              "
            />
            <DropdownInput
              v-model="i_gender"
              :label="$t('item_gender')"
              :placeholder="$t('choose_item_gender')"
              :items="genderOptions"
              :rules="no_rule"
            />
            <DropdownInput
              v-model="br_id"
              :label="$t('item_brand')"
              :placeholder="$t('choose_item_brand')"
              :items="convertToListIdValueBrands"
              :rules="no_rule"
              linkDrop="/brand"
            />
            <BaseInput
              v-model="i_longevity"
              type="number"
              :label="$t('item_longevity')"
              :placeholder="$t('item_longevity_hours')"
              :rules="no_rule"
            />
          </div>

          <!-- Multiple Images Section -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              {{ $t("item_images") }}
            </h3>
            <div class="space-y-4">
              <div
                v-for="(img, index) in item_images"
                :key="index"
                class="flex items-center space-x-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
              >
                <FileInput
                  :label="$t('item_image') + ' ' + (index + 1)"
                  :placeholder="$t('choose_item_image')"
                  @change="(files) => onChangeImage(files, index)"
                  accept="image/*"
                />
                <button
                  type="button"
                  @click="removeImage(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors duration-200"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addImage"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_image") }}
              </button>
            </div>
          </div>

          <!-- Sizes Section -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              {{ $t("item_sizes") }}
            </h3>
            <div class="space-y-4">
              <div
                v-for="(size, index) in item_sizes"
                :key="index"
                class="flex items-center space-x-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
              >
                <div class="flex-1">
                  <BaseInput
                    v-model="size.is_size"
                    :label="$t('size')"
                    :placeholder="$t('size_placeholder')"
                    :rules="no_rule"
                  />
                </div>
                <div class="flex-1">
                  <BaseInput
                    v-model="size.is_price"
                    type="number"
                    :label="$t('size_price')"
                    :placeholder="$t('size_price')"
                    :rules="no_rule"
                  />
                </div>
                <button
                  type="button"
                  @click="removeSize(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors duration-200"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addSize"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_size") }}
              </button>
            </div>
          </div>

          <!-- Seasons Section -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              {{ $t("item_seasons") }}
            </h3>
            <div class="space-y-4">
              <div
                v-for="(season, index) in item_seasons"
                :key="index"
                class="flex items-center space-x-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
              >
                <div class="flex-1">
                  <DropdownInput
                    v-model="season.ise_season"
                    :label="$t('season')"
                    :placeholder="$t('choose_season')"
                    :items="seasonOptions"
                    :rules="no_rule"
                  />
                </div>
                <div class="flex-1">
                  <BaseInput
                    v-model="season.ise_percentage"
                    type="number"
                    :label="$t('season_percentage')"
                    :placeholder="$t('season_percentage')"
                    :rules="no_rule"
                  />
                </div>
                <button
                  type="button"
                  @click="removeSeason(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors duration-200"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addSeason"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_season") }}
              </button>
            </div>
          </div>

          <!-- Use Time Section -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              {{ $t("item_use_time") }}
            </h3>
            <div class="space-y-4">
              <div
                v-for="(useTime, index) in item_use_times"
                :key="index"
                class="flex items-center space-x-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
              >
                <div class="flex-1">
                  <DropdownInput
                    v-model="useTime.iut_type"
                    :label="$t('use_time_type')"
                    :placeholder="$t('choose_use_time_type')"
                    :items="useTimeOptions"
                    :rules="no_rule"
                  />
                </div>
                <div class="flex-1">
                  <BaseInput
                    v-model="useTime.iut_percentage"
                    type="number"
                    :label="$t('use_time_percentage')"
                    :placeholder="$t('use_time_percentage')"
                    :rules="no_rule"
                  />
                </div>
                <button
                  type="button"
                  @click="removeUseTime(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors duration-200"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addUseTime"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_use_time") }}
              </button>
            </div>
          </div>

          <!-- Main Accords Notes Section -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              {{ $t("item_main_accords_notes") }}
            </h3>
            <div class="space-y-4">
              <div
                v-for="(accordNote, index) in item_accord_notes"
                :key="index"
                class="flex items-center space-x-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
              >
                <div class="flex-1">
                  <DropdownInput
                    v-model="accordNote.an_id"
                    :label="$t('accord_note')"
                    :placeholder="$t('choose_accord_note')"
                    :items="convertToListIdValueAccordsNotes"
                    :rules="no_rule"
                  />
                </div>
                <div class="flex-1">
                  <BaseInput
                    v-model="accordNote.ian_percentage"
                    type="number"
                    :label="$t('accord_note_percentage')"
                    :placeholder="$t('accord_note_percentage')"
                    :rules="no_rule"
                  />
                </div>
                <button
                  type="button"
                  @click="removeAccordNote(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors duration-200"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addAccordNote"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_accord_note") }}
              </button>
            </div>
          </div>

          <!-- Package Pricing Section -->
          <div class="mb-6">
            <h3 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              {{ $t("package_pricing") }}
            </h3>
            <div class="space-y-4 w-full md:w-1/2">
              <div
                v-for="(pkg, index) in i_packages"
                :key="index"
                class="flex items-center space-x-4 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg"
              >
                <div class="flex-1">
                  <BaseInput
                    v-model="pkg.name"
                    :label="$t('package_name')"
                    :placeholder="$t('package_name')"
                    :rules="no_rule"
                  />
                </div>
                <div class="flex-1">
                  <BaseInput
                    v-model="pkg.quantity"
                    type="number"
                    :label="$t('package_quantity')"
                    :placeholder="$t('package_quantity')"
                    :rules="no_rule"
                  />
                </div>
                <div class="flex-1">
                  <BaseInput
                    v-model="pkg.price"
                    type="number"
                    :label="$t('package_price')"
                    :placeholder="$t('package_price')"
                    :rules="no_rule"
                  />
                </div>
                <button
                  type="button"
                  @click="removePackage(index)"
                  class="px-3 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors duration-200"
                >
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
              <button
                type="button"
                @click="addPackage"
                class="w-full px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-200"
              >
                <i class="fa-solid fa-plus mr-2"></i>
                {{ $t("add_package") }}
              </button>
            </div>
          </div>

          <ButtonInput
            type="button"
            @click="addSaleItem"
            :label="$t('add')"
            :isLoading="isBtnLoading"
          />
        </form>
      </div>
    </div>
  </div>

  <ResultDialog ref="ResultDialog"></ResultDialog>
</template>
<script>
//import hearder-app
import HeaderApp from "../../components/Navbar/header-app.vue";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import TextAreaInput from "../../components/Inputs/TextAreaInput.vue";
import ButtonInput from "../../components/Inputs/ButtonInput.vue";
import FileInput from "../../components/Inputs/FileInput.vue";
import { formatDate } from "../../utils/functions";
import ResultDialog from "../../components/Modals/ResultDialog.vue";
import { CURRENCYS } from "../../constants/config";
import DropdownInput from "../../components/Inputs/DropdownInput.vue";
//import Compressor from "compressorjs";
export default {
  name: "ADD_SALE_TYPE",
  components: {
    HeaderApp,
    BaseInput,
    ButtonInput,
    ResultDialog,
    TextAreaInput,
    DropdownInput,
    FileInput,
  },
  data() {
    return {
      rules: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_fill_this_field");
        },
      ],
      no_rule: [],
      isSubmited: false,
      rules_dropdown: [
        (value) => {
          if (value) return true;

          return this.$t("you_must_choose_an_option");
        },
      ],
      currencys: CURRENCYS,
      ca_id: "",
      un_id: "",
      i_desc: "",
      i_name: "",

      i_expire_date: "",
      i_image: "",
      i_quantity: "",
      i_id: "",
      i_sale_price: "",
      cur_id: "",
      i_packages: [],
      i_gender: "",
      br_id: "",
      i_longevity: "",
      i_is_famous: 0,
      item_images: [],
      item_sizes: [],
      item_seasons: [],
      item_use_times: [],
      item_accord_notes: [],
      genderOptions: [
        { id: "male", value: this.$t("male") },
        { id: "female", value: this.$t("female") },
        { id: "both", value: this.$t("both") },
      ],
      seasonOptions: [
        { id: "spring", value: this.$t("spring") },
        { id: "winter", value: this.$t("winter") },
        { id: "summer", value: this.$t("summer") },
        { id: "autumn", value: this.$t("autumn") },
      ],
      useTimeOptions: [
        { id: "day", value: this.$t("day") },
        { id: "night", value: this.$t("night") },
      ],
    };
  },
  created() {
    this.$store.dispatch("item_category/getCategory");
    this.$store.dispatch("item_unit/getUnits");
    this.$store.dispatch("brand/getItems");
    this.$store.dispatch("accords_note/getAccordsNotes");
  },
  watch: {
    cur_id(newVal) {
      // If sizes array is empty and currency is selected, add default sizes
      if (newVal && this.item_sizes.length === 0) {
        this.item_sizes = [
          { is_size: "30ml", is_price: 0, cur_id: newVal },
          { is_size: "50ml", is_price: 0, cur_id: newVal },
          { is_size: "100ml", is_price: 0, cur_id: newVal },
        ];
      } else {
        // Update cur_id in all sizes when currency changes
        this.item_sizes.forEach(size => {
          if (!size.cur_id || size.cur_id === "" || size.cur_id === null) {
            size.cur_id = newVal || null;
          }
        });
      }
    }
  },

  computed: {
    isDark() {
      return this.$store.state.theme == "dark";
    },
    isBtnLoading() {
      return this.$store.state.add_item.isBtnLoading;
    },
    convertToListIdValue() {
      var list = [];
      for (const item of this.currencys) {
        list.push({
          id: item.cur_id,
          value: this.$t(item.cur_name),
        });
      }

      return list;
    },
    convertToListIdValueUnits() {
      var boxes = this.$store.state.item_unit.units;
      var list = [];
      for (const item of boxes) {
        list.push({
          id: item.un_id,
          value: item.un_name,
        });
      }

      return list;
    },

    convertToListIdValueCategory() {
      var categorys = this.$store.state.item_category.categorys;
      var list = [];
      for (const item of categorys) {
        list.push({
          id: item.ca_id,
          value: item.ca_name,
        });
      }

      return list;
    },
    convertToListIdValueBrands() {
      var brands = this.$store.state.brand.items;
      var list = [];
      for (const item of brands) {
        list.push({
          id: item.br_id,
          value: item.br_name,
        });
      }

      return list;
    },
    convertToListIdValueAccordsNotes() {
      var accordsNotes = this.$store.state.accords_note.accordsNotes;
      var list = [];
      for (const item of accordsNotes) {
        list.push({
          id: item.an_id,
          value: item.an_name,
        });
      }

      return list;
    },
  },

  methods: {generateBarcode() {
      //generate random 10 digit barcode
      this.i_id = Math.floor(
        1000000000 + Math.random() * 9000000000
      ).toString();
    },
    formatDate(date) {
      return formatDate(date);
    },

    async addSaleItem(e) {
      e.preventDefault();
      //check form validation
      if (this.$store.state.add_item.isBtnLoading) return;

      this.isSubmited = true;
      if (
        this.checkRulesIsError(this.ca_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.un_id, "add", this.rules_dropdown)
          .isError ||
        this.checkRulesIsError(this.i_name, "add", this.rules).isError ||
        this.checkRulesIsError(this.i_sale_price, "add", this.rules).isError ||
        this.checkRulesIsError(this.cur_id, "add", this.rules).isError
      ) {
        return;
      }
      
      // Validate packages: each package must have a name
      if (this.i_packages.length > 0) {
        for (let i = 0; i < this.i_packages.length; i++) {
          if (!this.i_packages[i].name || this.i_packages[i].name.trim() === '') {
            alert(this.$t('package_name_required') || 'Package name is required for all packages');
            return;
          }
        }
      }
  
      this.$store.state.add_item.isBtnLoading = true;
      
      // Prepare FormData for file uploads
      const formData = new FormData();
      formData.append("ca_id", this.ca_id);
      formData.append("un_id", this.un_id);
      formData.append("i_desc", this.i_desc || "");
      formData.append("i_name", this.i_name);
      formData.append("i_sale_price", this.i_sale_price);
      formData.append("cur_id", this.cur_id);
      formData.append("i_expire_date", this.i_expire_date || "");
      formData.append("i_quantity", this.i_quantity || "");
      formData.append("i_id", this.i_id || "");
      formData.append("i_gender", this.i_gender || "");
      formData.append("br_id", this.br_id || "");
      formData.append("i_longevity", this.i_longevity || "");
      formData.append("i_is_famous", this.i_is_famous || 0);
      
      if (this.i_packages && this.i_packages.length > 0) {
        formData.append("i_packages", JSON.stringify(this.i_packages));
      }
      
      // Add multiple images
      this.item_images.forEach((img, index) => {
        if (img.file) {
          formData.append(`images[${index}][file]`, img.file);
        }
      });
      
      // Add sizes - ensure cur_id is set
      if (this.item_sizes && this.item_sizes.length > 0) {
        const sizesToSend = this.item_sizes.map(size => ({
          is_size: size.is_size,
          is_price: size.is_price || 0,
          cur_id: size.cur_id || this.cur_id || null
        })).filter(size => size.is_size && size.is_size.trim() !== ""); // Only send sizes with names
        if (sizesToSend.length > 0) {
          formData.append("sizes", JSON.stringify(sizesToSend));
        }
      }
      
      // Add seasons as JSON
      if (this.item_seasons && this.item_seasons.length > 0) {
        const seasonsToSend = this.item_seasons.filter(s => s.ise_season && s.ise_percentage !== undefined);
        if (seasonsToSend.length > 0) {
          formData.append("seasons", JSON.stringify(seasonsToSend));
        }
      }
      
      // Add use times as JSON
      if (this.item_use_times && this.item_use_times.length > 0) {
        const useTimesToSend = this.item_use_times.filter(ut => ut.iut_type && ut.iut_percentage !== undefined);
        if (useTimesToSend.length > 0) {
          formData.append("use_times", JSON.stringify(useTimesToSend));
        }
      }
      
      // Add accord notes as JSON
      if (this.item_accord_notes && this.item_accord_notes.length > 0) {
        const accordNotesToSend = this.item_accord_notes.filter(an => an.an_id && an.ian_percentage !== undefined);
        if (accordNotesToSend.length > 0) {
          formData.append("accord_notes", JSON.stringify(accordNotesToSend));
        }
      }
      
      var res = await this.$store.dispatch("add_item/addNewItem", formData);
      if (res.status == 200) {
        this.i_desc = "";
        this.i_name = "";
        this.i_expire_date = "";
        this.i_image = "";
        this.i_quantity = "";
        this.ca_id = "";
        this.$store.state.add_item.isBtnLoading = false;
        this.i_id = "";
        this.i_sale_price = "";
        this.i_packages = [];
        this.i_gender = "";
        this.br_id = "";
        this.i_longevity = "";
        this.i_is_famous = 0;
        this.item_images = [];
        // Reset sizes with default values
        this.item_sizes = [
          { is_size: "30ml", is_price: 0, cur_id: this.cur_id || null },
          { is_size: "50ml", is_price: 0, cur_id: this.cur_id || null },
          { is_size: "100ml", is_price: 0, cur_id: this.cur_id || null },
        ];
        this.item_seasons = [];
        this.item_use_times = [];
        this.item_accord_notes = [];
        this.isSubmited = false;
      }
      this.isSubmited = false;
    },
    checkRulesIsError(value, type, rules) {
      var isError = false;
      var errorMsg = "";
      if (type == "add") {
        if (this.isSubmited == false)
          return {
            isError: false,
            errorMsg: "",
          };
      }
      for (const rule of rules) {
        if (rule(value) !== true) {
          isError = true;
          errorMsg = rule(value);
          // Stop the loop
          break;
        } else {
          isError = false;
          errorMsg = "";
        }
      }

      return {
        isError: isError,
        errorMsg: errorMsg,
      };
    },
    addPackage() {
      this.i_packages.push({
        name: "",
        quantity: 1,
        price: 0,
      });
    },
    removePackage(index) {
      this.i_packages.splice(index, 1);
    },
    addImage() {
      this.item_images.push({ file: null });
    },
    removeImage(index) {
      this.item_images.splice(index, 1);
    },
    onChangeImage(files, index) {
      if (this.item_images[index]) {
        this.item_images[index].file = files[0] || null;
      }
    },
    addSize() {
      this.item_sizes.push({
        is_size: "",
        is_price: 0,
        cur_id: this.cur_id || null,
      });
    },
    removeSize(index) {
      this.item_sizes.splice(index, 1);
    },
    addSeason() {
      this.item_seasons.push({
        ise_season: "",
        ise_percentage: 0,
      });
    },
    removeSeason(index) {
      this.item_seasons.splice(index, 1);
    },
    addUseTime() {
      this.item_use_times.push({
        iut_type: "",
        iut_percentage: 0,
      });
    },
    removeUseTime(index) {
      this.item_use_times.splice(index, 1);
    },
    addAccordNote() {
      this.item_accord_notes.push({
        an_id: "",
        ian_percentage: 0,
      });
    },
    removeAccordNote(index) {
      this.item_accord_notes.splice(index, 1);
    },
  },
};
</script>
<style>
input[type="date"]::-webkit-calendar-picker-indicator {
  filter: invert(40%) sepia(96%) saturate(694%) hue-rotate(195deg)
    brightness(85%) contrast(88%);
}

input[type="file"] {
  display: none;
}
.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 12px;
  cursor: pointer;
}
</style>
